import App from './App.svelte';

const app = new App({
  target: document.body,

  // configurable application options passed into App.svelte
  props: {
    // IMPORTANT: most configurable values can be found in "../appConfig.js"

    // e.g. "title" below would need to have "export let title;" in App.svelte
    // title: 'A Title Example'
  }
});

export default app;
